module.exports = __webpack_public_path__ + "img/img3.8fb086cc.png";